export const ACCESS_HISTORY_PAGE_STATE = 'accessHistory'

export const SET_FILTERED = 'Casino/AccessHistoryPage/SET_FILTERED'
export const SET_FOCUSED = 'Casino/AccessHistoryPage/SET_FOCUSED'
